module.exports = __webpack_public_path__ + "img/banner-text-zh.28180fb7.png";